// extracted by mini-css-extract-plugin
export default {"tbutton":"TButton_tbutton__KQ3-d","tbuttonBackground":"TButton_tbuttonBackground__+v5XR","copyButton":"TButton_copyButton__FMv09"};